import React, { useEffect } from 'react';
import { H4 } from 'primitives/appTitle';
import PatternSvg from 'components/svg/patternSvg';
import classnames from 'classnames';

import Swiper from 'swiper';
// @ts-ignore
import { device } from 'helpers/helpers';
import { ShIntlMessageDefinition, ShText } from '@shoootin/translations';
import { AppGatsbyImage, AppGatsbyImageFluid } from '../../primitives/appImage';

export interface PrestationFigure {
  label: ShIntlMessageDefinition;
  text: ShIntlMessageDefinition;
}

const getSlides = (
  figures: PrestationFigure[],
  images: AppGatsbyImageFluid[],
) => {
  return figures.map((figure, index) => {
    return { label: figure.label, text: figure.text, image: images[index] };
  });
};

const PrestationPageFigures = ({
  figures,
  images,
  coverCaption,
}: {
  figures: PrestationFigure[];
  images: AppGatsbyImageFluid[];
  coverCaption: ShIntlMessageDefinition;
}) => {
  const slides = getSlides(figures, images);

  useEffect(() => {
    const options = {
      spaceBetween: device().isMobile ? 0 : 20,
      slidesPerView: device().isMobile ? 1 : 2,
      loop: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 3,
        loadOnTransitionStart: true,
      },
    };
    new Swiper('.prestation-figures', options);

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
      console.log('resize');
    }, 100);
  });

  return (
    <>
      <div className="container cover-caption">
        <p>
          <ShText message={coverCaption} />
        </p>

        <div className="prestation-figures swiper-container">
          <div className="swiper-wrapper">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={classnames(
                  ' prestation-figures__figure',
                  ' swiper-slide',
                )}
              >
                <div className="prestation-figures__image">
                  <AppGatsbyImage
                    fluid={slide.image}
                    style={{ position: 'absolute' }}
                  />
                  {index === 1 && <PatternSvg />}
                </div>
                <H4>
                  <ShText message={slide.label} />
                </H4>
                <p>
                  <ShText message={slide.text} />
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default PrestationPageFigures;
